import { createBrowserRouter } from 'react-router-dom';
import { Layout } from './Layout';
import NotFound from './NotFound';

export const declarationSorRouter = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        index: true,
        lazy: () => import('./pages/HomePage').then(m => ({ Component: m.HomePage })),
      },
      {
        path: 'declaration',
        lazy: () => import('./Declaration').then(m => ({ Component: m.Declaration })),
      },
      {
        path: 'success',
        lazy: () => import('./pages/SuccessPage').then(m => ({ Component: m.SuccessPage })),
      },
      {
        path: 'mentions-legales',
        lazy: () => import('./pages/LegalPlaceholderPage').then(m => ({ Component: m.LegalPlaceholderPage })),
      },
      {
        path: 'politique-de-confidentialite',
        lazy: () => import('./pages/LegalPlaceholderPage').then(m => ({ Component: m.LegalPlaceholderPage })),
      },
      {
        path: 'consultation',
        lazy: () => import('./pages/ConsultationDemandePage').then(m => ({ Component: m.ConsultationDemandePage })),
      },
      {
        path: 'conditions-generales',
        lazy: () => import('./pages/ConditionsGeneralesPage').then(m => ({ Component: m.ConditionsGeneralesPage })),
      },
      {
        path: '*',
        element: <NotFound />,
      }
    ]
  }
]);
